import React, { useCallback } from 'react';
import { useFocusEffect } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { useTrackEffect } from '@order/Telemetry';

import { LoyaltyOffers } from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';
import { useBraze } from '../../context/Braze';
import { useOtaOnScreenFocus } from '../../hooks';
import { HomeScreenContentV2 } from './components';
import { useOpenChatFromHomeScreen } from './hooks';

export const HomeScreen = () => {
  const openChatFromHomeScreen = useOpenChatFromHomeScreen();
  const { logCustomEvent } = useBraze();
  const isLoggedIn = useIsLoggedIn();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const logHomeViewedBrazeEvent = useCallback(() => {
    logCustomEvent('home.viewed', { isLoggedIn });
  }, [isLoggedIn, logCustomEvent]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useOtaOnScreenFocus();

  useTrackEffect('home.view');
  useFocusEffect(openChatFromHomeScreen);
  useFocusEffect(logHomeViewedBrazeEvent);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <HomeScreenContentV2 />

      <LoyaltyOffers.Modal />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
